const MIN_QUERY_LENGTH = 3;

export function normalizeSearchText(value) {
  return String(value || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[¿?¡!.,:;]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export function visibleSearchItems(items, roles) {
  return items.filter((item) => !item.requiresAdmin || roles?.admin);
}

function scoreItem(item, normalizedQuery, terms) {
  const title = normalizeSearchText(item.title);
  const keywords = normalizeSearchText(item.keywords || '');
  const haystack = `${title} ${keywords}`;

  if (!terms.every((term) => haystack.includes(term))) {
    return null;
  }

  let score = 0;
  if (title === normalizedQuery) score += 100;
  if (title.startsWith(normalizedQuery)) score += 50;
  if (title.includes(normalizedQuery)) score += 40;

  terms.forEach((term) => {
    if (title.split(' ').some((word) => word.startsWith(term))) score += 10;
    if (title.includes(term)) score += 5;
  });

  score += Math.max(0, 40 - (title.length - normalizedQuery.length));

  return score;
}

export function searchItems(items, query, limit = 8) {
  const normalizedQuery = normalizeSearchText(query);
  if (normalizedQuery.length < MIN_QUERY_LENGTH) {
    return { results: [], total: 0 };
  }

  const terms = normalizedQuery.split(' ').filter(Boolean);
  const ranked = items
    .map((item) => ({ item, score: scoreItem(item, normalizedQuery, terms) }))
    .filter((entry) => entry.score !== null)
    .sort((a, b) => b.score - a.score || a.item.title.localeCompare(b.item.title, 'es'));

  return {
    results: ranked.slice(0, limit).map((entry) => entry.item),
    total: ranked.length,
  };
}
